module.exports = __webpack_public_path__ + "img/banner-img.126a2235.jpg";